import SpriteSymbol from "svg-baker-runtime/browser-symbol";
import sprite from "svg-sprite-loader/runtime/browser-sprite.build";
var symbol = new SpriteSymbol({
  "id": "vcard",
  "use": "vcard-usage",
  "viewBox": "0 0 32 32",
  "content": "<symbol viewBox=\"0 0 32 32\" xmlns=\"http://www.w3.org/2000/svg\" fill=\"currentColor\" fill-rule=\"evenodd\" stroke-linejoin=\"round\" stroke-miterlimit=\"1.414\" id=\"vcard\"><path d=\"M28.8 3.2c.896 0 1.653.309 2.272.928.619.619.928 1.376.928 2.272v19.2c0 .853-.309 1.6-.928 2.24-.619.64-1.376.96-2.272.96H3.2c-.853 0-1.6-.32-2.24-.96C.32 27.2 0 26.453 0 25.6V6.4c0-.896.32-1.653.96-2.272C1.6 3.509 2.347 3.2 3.2 3.2h25.6zm0 22.4V6.4H3.2v19.2h25.6zm-14.4-6.272v2.88h-8v-2.88h8zm0-4.8v2.88h-8v-2.88h8zm0-4.8v2.88h-8v-2.88h8zm11.072 10.24l.128 2.24h-8c0-1.493.064-2.24.192-2.24 1.792-.469 2.688-1.173 2.688-2.112 0-.341-.288-.939-.864-1.792a4.926 4.926 0 01-.864-2.816c0-2.347.96-3.52 2.88-3.52s2.88 1.173 2.88 3.52a4.806 4.806 0 01-.896 2.816c-.597.853-.896 1.451-.896 1.792 0 .427.224.811.672 1.152a4.03 4.03 0 001.376.704l.704.256z\" fill-rule=\"nonzero\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol


//////////////////
// WEBPACK FOOTER
// ./src/img/svg/vcard.svg
// module id = L0YD
// module chunks = 39 44